import i18next from 'i18next'
import propTypes from 'prop-types'
import { Tooltip } from '../../../iba-components/Tooltip'
import { List } from '../../../iba-components/List'
import { LANG_LIST } from '../../constants'
import './languageSelect.css'

export const LanguageSelect = (props) => {
    const onSelectLanguage = (lang) => {
        i18next.setLang(lang)
    }
    const LogoutTooltip = () => {
        return <List data={LANG_LIST} itemKey="value" onItemClick={(key) => onSelectLanguage(key)} width={300} isDark />
    }

    return (
        <div className={props.className}>
            <Tooltip content={LogoutTooltip()} trigger="click" position="bottom-left" isDark>
                <span className={`Appkit4-icon icon-globe-outline language-select-icon`} />
            </Tooltip>
        </div>
    )
}

LanguageSelect.propTypes = {
    className: propTypes.string,
    onSelectLanguage: propTypes.func
}
